import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, Dispatch } from "../../../../store/configureStore";
import TobAddressForm, {
  TobAddressValuesType,
} from "../../../Address/TobAddressForm";

import * as styles from "./index.scss";
import { useIntl } from "react-intl";
import Icon from "../../../../components/icon";
import { PrimaryButton } from "../../../../wrappers/button";
import { Row, Col } from "antd";
import { useTheme } from "styled-components";

interface AddressProps {
  changeAddress: any;
  classNamePrefix?: string;
}
const AddressContent: React.FC<AddressProps> = ({
  classNamePrefix = "",
  changeAddress,
}) => {
  const { bussinessPrimaryColor, borderColor } = useTheme();
  const dispatch = useDispatch<Dispatch>();
  const { formatMessage: f } = useIntl();

  const { tobAddress, breadcrumbs = [] } = useSelector(
    (state: RootState) => state.AddressPage,
  );

  const [addressFormOpen, setFormOpen] = useState(false),
    [addRessFormChangeOpen, setChangeOpen] = useState(false),
    [changeAddressId, setAddressId] = useState(0);

  const handleOpenChangeForm = (addressId: string) => {
    setChangeOpen(true);
    setAddressId(Number(addressId));
  };

  const handleChangeAddressItem = (addressValues: TobAddressValuesType) => {
    const data = {
      ...addressValues,
      tob_address_id: changeAddressId as any,
      callback: () => {
        if (addressValues.is_default === 1) {
          tobAddress.map((item, index) => {
            if (parseInt(item.tob_address_id) !== changeAddressId) {
              item.is_default = 0;
            }
          });
        }
        setChangeOpen(false);
        setAddressId(0);
        dispatch.AddressPage.setTobAddress();
      },
    };
    dispatch.AddressPage.addTobAddress(data);
  };

  const handleAddAddressItem = (addressValues: TobAddressValuesType) => {
    const data = {
      ...addressValues,
      callback: () => {
        if (addressValues.is_default === 1) {
          tobAddress.map((item, index) => {
            item.is_default = 0;
          });
        }
        setFormOpen(false);
        dispatch.AddressPage.setTobAddress();
      },
    };
    dispatch.AddressPage.addTobAddress(data);
  };

  return (
    <div className={styles["Address-box"]} style={{ padding: "24px" }}>
      <div>
        {tobAddress &&
          tobAddress.map((item, index) => {
            return (
              <Row>
                <Col
                  span={24}
                  style={{ marginBottom: "10px" }}
                  onClick={() => {
                    changeAddress(index);
                  }}
                >
                  <div
                    style={{
                      background: "white",
                      padding: "20px",
                      border: "2px solid",
                      cursor: "pointer",
                      boxSizing: "border-box",
                      borderRadius: "5px",
                      borderColor:
                        Number(item.is_select) === 1
                          ? bussinessPrimaryColor
                          : borderColor,
                    }}
                  >
                    <Row type={"flex"} align={"middle"}>
                      <Col span={18}>
                        <div>
                          {item.recipient_name}
                          {"  "}
                          {item.recipient_telephone}
                        </div>
                        <div>{item.recipient_email}</div>
                        <div>{item.recipient_company}</div>
                        <div>{`${item.province}${item.city}${item.area}${item.address_details}`}</div>
                      </Col>
                      <Col span={6} style={{ textAlign: "right" }}>
                        <PrimaryButton
                          onClick={e => {
                            e.stopPropagation();
                            handleOpenChangeForm(item.tob_address_id);
                          }}
                          shape={"circle"}
                          icon={<Icon type={"iconbianji"} />}
                          bgColor={bussinessPrimaryColor}
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          })}
        <Row style={{ textAlign: "right" }}>
          <Col span={14}></Col>
          <Col span={10}>
            <PrimaryButton
              block
              onClick={() => setFormOpen(true)}
              bgColor={bussinessPrimaryColor}
              style={{
                height: "50px",
                fontSize: "1.4em",
              }}
            >
              {f({ id: "AddNewAddress" })}
            </PrimaryButton>
          </Col>
        </Row>
      </div>
      <TobAddressForm
        isOpen={addressFormOpen}
        onClose={() => setFormOpen(false)}
        onSubmit={handleAddAddressItem}
      />
      {/* 用于修改地址的弹窗 */}
      <TobAddressForm
        isOpen={addRessFormChangeOpen}
        onClose={() => {
          setChangeOpen(false);
          setAddressId(0);
        }}
        onSubmit={handleChangeAddressItem}
        addressData={
          addRessFormChangeOpen
            ? tobAddress.find(
                item => Number(item.tob_address_id) === changeAddressId,
              )
            : undefined
        }
      />
    </div>
  );
};

export default React.memo(AddressContent);
